// extracted by mini-css-extract-plugin
export default {"counters":"style_counters__X+fmn","counter":"style_counter__gzvk2","counterIcon":"style_counterIcon__VyIa6"};